import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { getEndpoint } from '../config';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
          const res = await fetch(getEndpoint('LOGIN'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    const data = await res.json();
    setLoading(false);
    if (res.ok && data.token) {
      localStorage.setItem('token', data.token);
      window.location.href = '/';
    } else {
      setError(data.error || 'خطا در ورود');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Paper elevation={4} sx={{ p: 4, minWidth: 340, borderRadius: 3, boxShadow: 3, fontFamily: 'Vazir' }}>
        <Typography variant="h5" align="center" sx={{ mb: 3, fontWeight: 'bold', fontFamily: 'Vazir' }}>
          ورود به پنل مدیریت
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="نام کاربری"
            fullWidth
            margin="normal"
            value={username}
            onChange={e => setUsername(e.target.value)}
            sx={{ fontFamily: 'Vazir' }}
            inputProps={{ style: { fontFamily: 'Vazir' } }}
          />
          <TextField
            label="رمز عبور"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
            sx={{ fontFamily: 'Vazir' }}
            inputProps={{ style: { fontFamily: 'Vazir' } }}
          />
          {error && <Alert severity="error" sx={{ mt: 2, fontFamily: 'Vazir' }}>{error}</Alert>}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2, fontFamily: 'Vazir', fontWeight: 'bold', py: 1.2 }}
            disabled={loading}
          >
            {loading ? 'در حال ورود...' : 'ورود'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default Login; 